module.exports = __webpack_public_path__ + "img/good.5a1344e4.png";